import React from 'react'
import { Route } from 'react-router-dom'
import { RecordRoute } from '../../../../shared/page/record-route'
import { SelfRegisterList } from './content/self-register-list'
import { SelfRegisterEdit } from './content/self-register-edit'
import { SelfRegisterAdd } from './content/self-register-add'
import { Delete } from '../../../../shared/page/page-delete'
import { useApFormSelfRegister } from '../../../../api-new/state/content'
import { Purge } from '../../../../shared/page/page-purge'
import { SelfRegisterRecycle } from './content/self-register-recycle'

export const LayoutSelfRegister = () => {
  return (
    <React.Fragment>
      <Route path="/org/self-register/list" component={SelfRegisterList} />
      <Route path="/org/self-register/list/add" component={SelfRegisterAdd} />
      <RecordRoute path="/org/self-register/list/edit/:selfRegisterID" component={SelfRegisterEdit} />
      <RecordRoute path="/org/self-register/list/edit/:deleteID/delete">
        <Delete useApiForm={useApFormSelfRegister} titleParam="name" successPath="/org/self-register/list" />
      </RecordRoute>

      <Route path="/org/self-register/list/recycle" component={SelfRegisterRecycle} />
      <RecordRoute path="/org/self-register/list/recycle/purge/:purgeID">
        <Purge useApiForm={useApFormSelfRegister} titleParam="name" successPath="/org/self-register/list/recycle" />
      </RecordRoute>
    </React.Fragment>
  )
}
